import { useEffect } from "react";


const getPreferredVoice = (voices) =>
    voices.find((v) => v.name.includes("Male")) ||
    voices.find((v) => v.name === "Google UK English Male") ||
    voices.find((v) => v.name === "Google US English") ||
    voices.find((v) => v.lang.startsWith("en")) ||
    voices[0] || null;


const useVoiceLoader = (setVoices, setSelectedVoice) => {
    useEffect(() => {
        const synthesis = window.speechSynthesis;
        if (!synthesis) return;

        const loadVoices = () => {
            const availableVoices = synthesis.getVoices();
            setVoices(availableVoices);
            setSelectedVoice(getPreferredVoice(availableVoices));
        };

        loadVoices();
        synthesis.onvoiceschanged = loadVoices;

        return () => {
            synthesis.onvoiceschanged = null;
        };
    }, [setVoices, setSelectedVoice]);
};

export default useVoiceLoader;